export default __webpack_public_path__ + "static/media/Automation.226297e0.svg";